import React from "react";
import { SmmDomainRequestsTable } from "../../UI/SmmDomain/SmmDomainRequestsTable";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelHead from "../../UI/Panel/PanelHead";

const SmmDomainRequests = () => {
  return (
    <div>
      <PanelHead title="Marketer" />
      <PanelBody content={<SmmDomainRequestsTable />} />
    </div>
  );
};

export default SmmDomainRequests;
